import React, { memo } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Add, Delete, Save } from "@mui/icons-material";

import { formatarValor, somarPorcentagens } from "../utils";

function DetalheRateioNota({
  row,
  isExpanded,
  isLoading,
  isSaving,
  draft,
  erro,
  onAdd,
  onRemove,
  onChange,
  onCancelar,
  onSalvar,
}) {
  const somaAtual = somarPorcentagens(draft);

  return (
    <TableRow>
      <TableCell
        colSpan={6}
        sx={{
          p: 0,
          borderBottom: isExpanded ? "1px solid #e9ecef" : 0,
          backgroundColor: "#fcfcfd",
        }}
      >
        <Collapse in={isExpanded} timeout={220} unmountOnExit>
          <Box sx={{ p: 1.5, marginTop: 1 }}>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  py: 1,
                }}
              >
                <CircularProgress size={18} />
                <Typography variant="body2">Carregando competencias...</Typography>
              </Box>
            ) : (
              <>
                {draft.length === 0 && (
                  <Typography variant="body2" sx={{ color: "#666", mb: 1.5 }}>
                    Nenhuma competencia cadastrada para esta nota.
                  </Typography>
                )}

                {draft.map((item, index) => (
                  <Box
                    key={`comp-${row.id}-${index}`}
                    sx={{
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                      mb: 1,
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      label="Mes"
                      placeholder="MM"
                      value={item.mes_competencia}
                      onChange={(event) =>
                        onChange(index, "mes_competencia", event.target.value)
                      }
                      size="small"
                      sx={{ width: 110 }}
                      inputProps={{ maxLength: 2 }}
                    />
                    <TextField
                      label="Ano"
                      placeholder="AAAA"
                      value={item.ano_competencia}
                      onChange={(event) =>
                        onChange(index, "ano_competencia", event.target.value)
                      }
                      size="small"
                      sx={{ width: 120 }}
                      inputProps={{ maxLength: 4 }}
                    />
                    <TextField
                      label="Porcentagem"
                      type="number"
                      value={item.porcentagem}
                      onChange={(event) =>
                        onChange(index, "porcentagem", event.target.value)
                      }
                      size="small"
                      sx={{ width: 160 }}
                      inputProps={{
                        step: "0.0001",
                        min: "0",
                        max: "100",
                      }}
                    />
                    <Typography variant="body2">%</Typography>
                    <Box sx={{ ml: "auto", minWidth: 260 }}>
                      <Typography
                        variant="body2"
                        sx={{ textAlign: "right", color: "#555" }}
                      >
                        Valor referente:{" "}
                        {formatarValor(
                          (Number(row.valor || 0) * Number(item.porcentagem || 0)) /
                            100
                        )}
                      </Typography>
                    </Box>
                    <IconButton
                      aria-label="Remover competencia"
                      title="Remover competencia"
                      color="error"
                      onClick={() => onRemove(index)}
                    >
                      <Delete />
                    </IconButton>
                  </Box>
                ))}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1.5,
                  }}
                >
                  <Button variant="outlined" startIcon={<Add />} onClick={onAdd}>
                    Adicionar competencia
                  </Button>

                  <Typography variant="body2" sx={{ color: "#666" }}>
                    Soma atual: {somaAtual.toFixed(2)}%
                  </Typography>
                </Box>

                {erro && (
                  <Alert severity="error" sx={{ mt: 1.5 }}>
                    {erro}
                  </Alert>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1.5,
                  }}
                >
                  <Button variant="outlined" onClick={onCancelar} disabled={isSaving}>
                    Cancelar
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<Save />}
                    onClick={onSalvar}
                    disabled={isSaving || isLoading}
                  >
                    {isSaving ? "Salvando..." : "Salvar"}
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}

export default memo(DetalheRateioNota);
